<template>
  <div class="table__row" :class="{'table__row--dec': !info.active}">
    <div class="table__cell">
      <toggle-button color="#0290FC" :width="40" :sync="true" v-model="info.active" />
    </div>
    <div class="table__cell">
      <div class="table__cell-title">{{ info.name }}</div>
    </div>
    <div class="table__cell">
      <div class="table__cell-title">{{ info.price }}</div>
    </div>
    <div class="table__cell">
      <div class="indicator__wrapper">
        <span v-if="info.fuelSurcharge" class="indicator indicator--green">yes</span>
        <span v-else class="indicator indicator--orange">no</span>
      </div>
    </div>
    <div class="table__cell table__cell--horizontal">
      <span class="table__cell-title" v-for="shift in info.shifts" :key="shift.id">{{ shift.name }}</span>
    </div>
  </div>
</template>

<script>
import {ToggleButton} from 'vue-js-toggle-button'

export default {
  name: 'Service',
  components: {
    ToggleButton
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
